import { cn } from '@/utils/cn';

export function PageSection({
  title,
  actions,
  children,
  className,
}: {
  title: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <section className={cn('space-y-4', className)}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="text-headline-md font-semibold text-foreground">{title}</h2>
        {actions}
      </div>
      {children}
    </section>
  );
}
